import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { IEventHeader } from '../models/event.model'

/**
 * <example-url>http://localhost:6006/?path=/story/angular-components-shared-section-header--section-header</example-url>
 */
@Component({
  selector: 'flo-section-header',
  styleUrls: ['./section-header.component.scss'],
  templateUrl: './section-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionHeaderComponent {
  @Input() public event: IEventHeader
  @Output() readonly buttonClick = new EventEmitter<any>()

  public onButtonClick() {
    this.buttonClick.next(true)
  }
}
